export default "__VITE_ASSET__DgTijM2T__"